function Louise({imgsrc}){
    return(
        <div>
            <h2>Hi, Louise!</h2>
            <img alt="camera" style={{maxWidth:"80%", display: "block", margin:"0 auto", padding: 0}} src={imgsrc}/>
            <p>[It would be] Nice to meet you!</p>
        </div>
    )
}
export default Louise